import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/en";

export default {
  locale: "en",
  name: "Conditions",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "conditionType",
        displayName: "Condition type",
        optionDisplay: {
          ENGINE: { label: "Engine" },
          STORE: { label: "Store" },
          FLIGHT_HOTEL: { label: "Flight + Hotel" },
        },
      },
      {
        fieldName: "earlyCharge",
        displayName: "%deposit",
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Charge first night",
      },
      {
        fieldName: "policies",
        displayName: "Cancellation policies",
      },
      {
        fieldName: "payments",
        displayName: "Payment methods",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Minimum charge",
      },
      {
        fieldName: "motorsList",
        displayName: "Motors",
      },
      {
        fieldName: "uso",
        displayName: "Usage",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "ticker",
        displayName: "Ticker",
      },
      {
        fieldName: "conditionType",
        displayName: "Store condition",
      },
      {
        fieldName: "isFlightHotelCondition",
        displayName: "Flight + Hotel condition",
      },
      {
        fieldName: "flightHotelPaymentType",
        displayName: "Prepayment (Maarlab)",
        optionDisplay: {
          FLIGHT_ONLY: { label: "Flight only" },
          ALL_NOW: { label: "All now" },
          // Temporarily disabled: FLIGHT_NOW_HOTEL_LATER is not offered for now.
          // FLIGHT_NOW_HOTEL_LATER: { label: "Flight now / hotel later" },
        },
      },
      {
        fieldName: "color",
        displayName: "Color",
      },
      {
        fieldName: "payments",
        displayName: "Payment methods",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "earlyCharge",
        displayName: "% Advance deposit",
      },
      {
        fieldName: "minimumCharge",
        displayName: "Minimum charge",
      },
      {
        fieldName: "policies",
        displayName: "Cancellation policies",
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: <FormattedMessage {...globalMessages.selectNone} />,
      },
      {
        fieldName: "chargeFirstNight",
        displayName: "Charge first night",
      },
      {
        fieldName: "name",
        displayName: "Name",
      },
      {
        fieldName: "htmlCancellation",
        displayName: "Cancellations / Prepayment",
      },
      {
        fieldName: "htmlCheckIn",
        displayName: "Check-in time",
      },
      {
        fieldName: "htmlCheckOut",
        displayName: "Check-out time",
      },
      {
        fieldName: "htmlChildren",
        displayName: "Children and extra beds",
      },
      {
        fieldName: "htmlPets",
        displayName: "Pets",
      },
      {
        fieldName: "htmlGroups",
        displayName: "Groups",
      },
      {
        fieldName: "htmlExtraInfo",
        displayName: "More information",
      },
      {
        fieldName: "selectedMotorsSection",
        displayName: "Property selection",
      },
    ],
  },
};
